import "reflect-metadata";
import { container } from "tsyringe";
import BookingServices from "./bookingServices";
import LoadingServices from "./loadingServices";
export const DependencyInjectorServicesApplication = () => {
    container.register("IBookingServices", { useClass: BookingServices });
    container.register("ILoadingServices", { useClass: LoadingServices });
};
export default DependencyInjectorServicesApplication;
